exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-border[data-v-15100a14] {\n  border-top: solid 2px #29bf12;\n  border-bottom: solid 2px #687074;\n}\n.border-bottom[data-v-15100a14]:not(:last-child) {\n  border-bottom: 0.5px solid gray;\n}\n.menu-button[data-v-15100a14] {\n  width: 100%;\n  text-align: left;\n  padding: 0.5rem;\n  background-color: white;\n  color: #505658;\n  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n}\n.menu-button[data-v-15100a14]:hover {\n  background-color: #999999;\n  color: white;\n}\n", ""]);

// exports
